/**
 * Higher order function to create multiple instances of the same store
 *
 * @example const useCarStore = makeSeparateStore((id: string) => defineStore(`car/${id}`, config))
 */
export function makeSeparatedStore<
  T extends (storeKey: string) => any,
  K extends T extends (storeKey: string) => infer StoreDef ? StoreDef : never,
>(defineStore: T) {
  const definedStores = new Map<string, K>()

  return (storeKey: string): ReturnType<K> => {
    if (!definedStores.has(storeKey)) {
      definedStores.set(storeKey, defineStore(storeKey))
    }

    // eslint-disable-next-line ts/ban-ts-comment
    // @ts-expect-error
    return definedStores.get(storeKey)()
  }
}
